import React, { useEffect, useState, useMemo } from "react";
import { BrowserRouter } from "react-router-dom";
import { NotificationProvider, LoadingProvider } from "@cisco/spaces-dash-app-business-hierarchy";
import { I18nContext } from "./contexts/i18nContext";
import { PropertiesContext } from "./contexts/propertiesContext";
import App from "./components/app/app";
import * as PartnerHomeService from "./service/partner-dashboard-service";

export default function PartnerDashboardHome(props) {
  const {
    appData: { i18n }
  } = props;

  const [properties, setProperties] = useState(null);
  const contextValue = useMemo(() => ({ properties, setProperties }), [properties, setProperties]);

  const fetchDashboardProperties = async () => {
    try {
      const res = await PartnerHomeService.getDashboardProperties();
      if (res?.status) {
        setProperties(res.data); // Set the properties state with the response data
      } else {
        console.error("Failed to fetch dashboard properties. Response status is false.");
      }
    } catch (error) {
      console.error("Error fetching dashboard properties:", error);
    }
  };

  useEffect(() => {
    fetchDashboardProperties();
  }, []);
  if (!properties) {
    return null;
  }

  return (
    <I18nContext.Provider value={i18n}>
      <BrowserRouter>
        <NotificationProvider>
          <LoadingProvider>
            <PropertiesContext.Provider value={contextValue}>
              <App i18n={i18n} />
            </PropertiesContext.Provider>
          </LoadingProvider>
        </NotificationProvider>
      </BrowserRouter>
    </I18nContext.Provider>
  );
}
